import React, { useCallback, useState } from 'react';
import { CorporateActionsWidgetGrid } from 'widgets/corpActions/widget/grid/CorporateActionsWidgetGrid';
import { GridApi } from '@instinet-analytics/semantic-ui-components';
import { SymbolEvent } from 'widgets/corpActions/data/SymbolEvent';
import { CorporateActionsWidgetDetails } from 'widgets/corpActions/widget/details/CorporateActionsWidgetDetails';
import { DockingPanel } from '@instinet-analytics/semantic-ui-components';
import { useWidgetWithDockablePanelDimensions } from 'widgets/utils/useWidgetWithDockablePanelDimensions';
import { initialCorporateActionsConfiguration } from 'widgets/corpActions/widget/store/config/CorporateActionsWidgetConfigState';

export interface CorporateActionsWidgetContentProps {
    onGridApiSet: (gridApi: GridApi) => void;
}

export function CorporateActionsWidgetContent(
    props: CorporateActionsWidgetContentProps
) {
    const { onGridApiSet } = props;
    const [selectedCorporateAction, setSelectedCorporateAction] = useState<
        SymbolEvent | undefined
    >();

    const {
        mainPanelHeight,
        dockablePanelHeight,
        dockablePanelWidth,
        dockablePanelFirst,
        percentage,
        position,
        handlePercentageChange,
    } = useWidgetWithDockablePanelDimensions({
        showDockablePanel: !!selectedCorporateAction,
        tallPanelHeader: true,
        initialConfig: initialCorporateActionsConfiguration,
    });

    const onRowSelected = useCallback((row: SymbolEvent | undefined) => {
        setSelectedCorporateAction(row);
    }, []);

    return (
        <div className="CorporateActionsWidgetContent">
            <DockingPanel
                percentage={percentage}
                onPercentageChange={handlePercentageChange}
                position={position}
            >
                {dockablePanelFirst && selectedCorporateAction && (
                    <CorporateActionsWidgetDetails
                        height={dockablePanelHeight}
                        width={dockablePanelWidth}
                        corporateAction={selectedCorporateAction!}
                    />
                )}
                <CorporateActionsWidgetGrid
                    height={mainPanelHeight}
                    onGridApiSet={onGridApiSet}
                    onRowSelected={onRowSelected}
                />
                {!dockablePanelFirst && selectedCorporateAction && (
                    <CorporateActionsWidgetDetails
                        height={dockablePanelHeight}
                        width={dockablePanelWidth}
                        corporateAction={selectedCorporateAction!}
                    />
                )}
            </DockingPanel>
        </div>
    );
}
